module.exports = __webpack_public_path__ + "img/whats-next.b7696261.png";